module.exports = __webpack_public_path__ + "static/media/more-vert.a2383be2.svg";